export default "__VITE_ASSET__DwRbfu6o__"